<template>
<div>
  <b-card title="Documento de usuario a buscar" class="text-uppercase text-center">
    <b-col>
      <b-form-input v-on:change="searchId()" id="input-default" v-model="idSearch" type="text" placeholder="Documento"></b-form-input>
    </b-col>
  </b-card>
  <carnetsForm :typeEndPoint="'adminCarnetsForm'" :dataParams="{}" v-show="verForm" />
</div>
</template>
<script>
import carnetsForm from '@/components/modules/admin/carnets/form'
export default {
  name: 'carnetsFormCreate',
  components: {
    carnetsForm
  },
  data: function () {
    return {
      verForm: false,
      idSearch: ''
    }
  },
  methods: {
    searchId: function (msg) {
      this.$store.dispatch('adminValidateUser', this.idSearch).then((response) => {
        var name = document.getElementsByName('name_user_primary')[0]
        name.value = 'juan'
        console.log(response)
        this.verForm = response.response
      }).catch((error) => {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/create.vue